import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@api/client/apiClient';
import { queryKeys } from '@api/queryKeys';
import type { Route, Waypoint } from '../types';

interface SaveRouteInput {
  routeId?: string;
  name: string;
  waypoints: Waypoint[];
  corridorNm?: number;
  isCurrent?: boolean;
}

export function useSaveRoute() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (input: SaveRouteInput) => {
      if (input.routeId) {
        return apiClient.put<Route>(`/routes/${input.routeId}`, input);
      }
      return apiClient.post<Route>('/routes', input);
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: queryKeys.routes.all });
    },
  });
}
